import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-export-dialog',
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss']
})
export class ExportDialogComponent implements OnInit {
  exportForm: FormGroup;

  exportOptions = [
    { label: 'CSV', value: 'csv' },
    { label: 'CSV (Excel)', value: 'csv_excel' },
    { label: 'Google Sheets', value: 'google_sheets' },
  ];

  constructor(
    public dialogRef: MatDialogRef<ExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private formBuilder: FormBuilder
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.exportForm = this.formBuilder.group({
      name: ['', Validators.required],
      exportOption: ['csv', Validators.required], // Default export option
      //keepValueFormatting: false, // Default to not keeping value formatting
    });
  }
  onSubmit() {
    const selectedOption = this.exportForm.value.exportOption;
    console.log('Selected Export Option: ', selectedOption);
    // Implement your export logic based on the selectedOption
  }

}
